import {
  Dialog,
  DialogContent,
  DialogTitle,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';
import { CleaningMissionSortOrder, cleaningMissionSortOrders } from '@silbo/core';
import { CheckIcon } from '@silbo/ui';
import { useTranslation } from 'react-i18next';

type SortOrderDialogProps = {
  open: boolean;
  sortOrder: CleaningMissionSortOrder;
  onClose: () => void;
  onApply: (order: CleaningMissionSortOrder) => void;
};

const SortOrderDialog = ({ open, sortOrder, onClose, onApply }: SortOrderDialogProps) => {
  const { t } = useTranslation('environmental-cleaning');

  const choose = (order: CleaningMissionSortOrder) => {
    onApply(order);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>
        <Typography variant="h2">{t('missions.sort.title')}</Typography>
      </DialogTitle>
      <DialogContent>
        <List disablePadding>
          {cleaningMissionSortOrders.map((order) => (
            <ListItemButton key={order} selected={order === sortOrder} onClick={() => choose(order)}>
              <ListItemIcon>{order === sortOrder && <CheckIcon color="primary" fontSize="small" />}</ListItemIcon>
              <ListItemText primary={t(`missions.sort.${order}`)} />
            </ListItemButton>
          ))}
        </List>
      </DialogContent>
    </Dialog>
  );
};

export default SortOrderDialog;
